export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "dicc_admin_token";
export const TZ = "America/New_York";

export const fileUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);
export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const day = (x) =>
  new Date(x).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric", timeZone: TZ });
const time = (x) => new Date(x).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", timeZone: TZ });

export function formatWhen(start, end) {
  if (!end) return [day(start), time(start)];
  if (day(start) === day(end)) return [day(start), `${time(start)} – ${time(end)}`];
  return [`${day(start)}, ${time(start)} –`, `${day(end)}, ${time(end)}`];
}

export const formatStamp = (x) =>
  new Date(x).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short", timeZone: TZ });
